import styled from 'styled-components'
import theme from '../../Theme'

export const FixedPositionMenuWrapper = styled.div`
    .bm-burger-button {
        position: fixed;
        width: 30px;
        height: 20px;
        right: 16px;
        top: 20px;
    }

    #react-burger-menu-btn {
        color: red
    }

    /* Color/shape of burger icon bars */
    .bm-burger-bars {
        transition: background 0.15s;
        background: ${theme.dark};
    }

    /* Color/shape of burger icon bars on hover*/
    .bm-burger-bars-hover {
        transition: background 0.15s;
        background: ${theme.light};
    }

    /* Position and sizing of clickable cross button */
    .bm-cross-button {
        height: 50px;
        width: 50px;
        display: none;
    }

    /* Color/shape of close button cross */
    .bm-cross {
        background: ${theme.dark};
    }

    /*
    Sidebar wrapper styles
    Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
    */
    .bm-menu-wrap {
        // position: fixed;
        height: 100%;
        width: 300px !important;
    }

    /* General sidebar styles */
    .bm-menu {
        border-radius: 3px 0 0 0;
        background: ${theme.background};
        padding: 1.5em 1.5em 0;
        font-size: 1.15em;
        /* Prevents extra scrollbar on Edge.  Have to use important because it's an inline style */
        overflow: hidden !important;
    }

    /* Morph shape necessary with bubble or elastic */
    .bm-morph-shape {
        fill: ${theme.dark};
    }

    /* Styling of overlay */
    .bm-overlay {
    background: rgba(0, 0, 0, 0.4);
        top: 0;
        left: 0;
    }

    width: 50px;

    
`

export const UnfixedMenuWrapper = styled.div`
    .bm-burger-button {
        position: relative;
        // position: fixed;
        width: 30px;
        height: 20px;
        // right: 16px;
        // top: 20px;
    }

    #react-burger-menu-btn {
        color: red
    }

    /* Color/shape of burger icon bars */
    .bm-burger-bars {
        transition: background 0.15s;
        background: ${theme.dark};
    }

    /* Color/shape of burger icon bars on hover*/
    .bm-burger-bars-hover {
        transition: background 0.15s;
        background: ${theme.light};
    }

    /* Position and sizing of clickable cross button */
    .bm-cross-button {
        height: 50px;
        width: 50px;
    }

    /* Color/shape of close button cross */
    .bm-cross {
        background: ${theme.dark};
    }

    /*
    Sidebar wrapper styles
    Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
    */
    .bm-menu-wrap {
        // position: fixed;
        height: 100%;
        width: 200px !important;
    }

    /* General sidebar styles */
    .bm-menu {
        background: ${theme.background};
        padding: 2.5em 1.5em 0;
        font-size: 1.15em;
        /* Prevents extra scrollbar on Edge.  Have to use important because it's an inline style */
        overflow: hidden !important;
    }

    /* Morph shape necessary with bubble or elastic */
    .bm-morph-shape {
        fill: ${theme.dark};
    }

    /* Styling of overlay */
    .bm-overlay {
    background: rgba(0, 0, 0, 0.4);
        top: 0;
        left: 0;
    }

    width: 50px;

    
`